module.exports = __webpack_public_path__ + "img/burnley.a38d4377.png";